import React from 'react';
import { TradeData } from 'containers/RealTimeData';

// Always mount TradeData using the trading pair from the URL params. Previously
// this waited for the markets list to populate from the MK WebSocket event, but
// the backend only pushes MK on market updates (not on subscribe), so on a
// quiet environment TradeData never mounted and the OrderBook stayed empty.
// The URL params are authoritative for which pair to subscribe to.
class ExchangeDataWrapper extends React.PureComponent {
  render() {
    const { match } = this.props;
    const currentTradingPair = match.params;
    return <TradeData tradingPair={currentTradingPair} />;
  }
}

export default ExchangeDataWrapper;
